module.exports = __webpack_public_path__ + "img/re1.58a37673.jpg";